// extracted by mini-css-extract-plugin
export var text = "_4w-0";